import _ from 'lodash';
import { httpAuth } from '@/utils/axios';

const init = () => ({
  national: null,
  memberTypes: [],
  scoringEvents: [],
  playerMovements: [],
  matchStatuses: [],
  seasons: [],
  currentSeason: undefined,
  timezone: 'Australia/Sydney',
  resolveDisputeSettings: [],
  transactionFee: 0,
  module: {},
});

export default {
  namespaced: true,
  state: init(),
  mutations: {
    updateNational(state, payload) {
      state.national = payload;
    },
    updateMemberTypes(state, payload) {
      state.memberTypes = payload;
    },
    updateScoringEvents(state, payload) {
      state.scoringEvents = payload;
    },
    updatePlayerMovements(state, payload) {
      state.playerMovements = payload;
    },
    updateMatchStatuses(state, payload) {
      state.matchStatuses = payload;
    },
    updateSeasons(state, payload) {
      state.seasons = payload;
    },
    updateCurrentSeason(state, payload) {
      state.currentSeason = payload;
    },
    updateTimezone(state, payload) {
      state.timezone = payload;
    },
    updateResolveDisputeSettings(state, payload) {
      state.resolveDisputeSettings = payload;
    },
    updateTransactionFee(state, payload) {
      state.transactionFee = payload;
    },
    updateModule(state, payload) {
      state.module = payload;
    },
  },
  actions: {
    async setup({ commit }) {
      const resNationalRequest = async () => {
        const res = await httpAuth.get('assemble/api/v1/manager/nationals/presentation');
        if (res.data.livescore) {
          commit('updateNational', { livescore: res.data.livescore, nationalLogo: res.data.nationalLogo || '' });
        }
        if (res.data.transactionFee !== undefined) {
          commit('updateTransactionFee', res.data.transactionFee);
        }
        if (res.data.module) {
          commit('updateModule', res.data.module);
        }
      };
      const resRequest = async () => {
        const res = await httpAuth.get('assemble/api/v1/manager/nationals/member-types');
        if (res.data.data) commit('updateMemberTypes', res.data.data);
      };
      const resSeasonsRequest = async () => {
        const resSeasons = await httpAuth.get('assemble/api/v1/manager/seasons');
        if(resSeasons.data.seasons){
          commit('updateSeasons', resSeasons.data.seasons);
          const currentSeason = _.find(resSeasons.data.seasons, s => s.currentSeason);
          if(currentSeason) commit('updateCurrentSeason', currentSeason);
        }
      };
      const resEventsRequest = async () => {
        const resEvents = await httpAuth.get('assemble/api/v1/manager/nationals/events');
        if (resEvents.data.scoringEvents) commit('updateScoringEvents', resEvents.data.scoringEvents);
        if (resEvents.data.playerMovements) commit('updatePlayerMovements', resEvents.data.playerMovements);
        if (resEvents.data.matchStatuses) commit('updateMatchStatuses', resEvents.data.matchStatuses);
        if (resEvents.data.timezone) commit('updateTimezone', resEvents.data.timezone);
      };
      const resResolveDisputeSettingsRequest = async () => {
        const resResolveDisputeSettings = await httpAuth.get('assemble/api/v1/manager/nationals/member-settings');
        if (resResolveDisputeSettings.data.data) commit('updateResolveDisputeSettings', resResolveDisputeSettings.data.data);
      };
      await Promise.all([resNationalRequest(), resRequest(), resEventsRequest(), resSeasonsRequest(), resResolveDisputeSettingsRequest()]);
    }
  },
  getters: {
    national(state) {
      return state.national;
    },
    memberTypes(state) {
      return _.get(state, 'memberTypes');
    },
    playingMemberTypes(state) {
      return _.filter(_.get(state, 'memberTypes'), t=> t.playing === true);
    },
    nonplayingMemberTypes(state) {
      return _.filter(_.get(state, 'memberTypes'), t=> t.playing !== true);
    },
    scoringEvents(state) {
      return state.scoringEvents;
    },
    playerMovements(state) {
      return state.playerMovements;
    },
    matchStatuses(state) {
      return state.matchStatuses;
    },
    seasons(state) {
      return state.seasons;
    },
    currentSeason(state) {
      return state.currentSeason;
    },
    timezone(state) {
      return state.timezone;
    },
    resolveDisputeSettings(state) {
      return state.resolveDisputeSettings;
    },
    transactionFee(state) {
      const raw = state.transactionFee;
      if (raw && typeof raw === 'object') return raw.domestic || 0;
      return raw || 0;
    },
    transactionFeeRaw(state) {
      return state.transactionFee;
    },
    module(state) {
      return state.module;
    },
  },
};
